import './table.scss';
import React, { useRef, useState } from 'react';
import { Typography, TableBody, TableRow, TableCell, Tooltip, Checkbox } from '@mui/material';
import { getTableTextColor, getTableCellBgColor } from '../../utils/commonUtils';
import TextOverFlowToolTip from './TextOverFlowToolTip';

export default function TableService({ rows, columns, onClickRow, tableBodyBgColor, showCheckBox = false, onChangeCheckBox }) {
  // Create Ref

  return (
    <TableBody
      className="table-body-container"
      style={{ backgroundColor: tableBodyBgColor }}
    >
      {rows?.map((rowItem, rowIndex) => (
        <TableRow
          style={{ width: '100%', cursor: Boolean(onClickRow) ? 'pointer' : 'auto' }}
          key={rowIndex}
          className={`hover:bg-[#14285A08] hover:border-transparent hide-border ${rowItem?.selected ? 'selectedRow' : ''} row-hover`}
          onClick={() => {
            if (onClickRow) {
              onClickRow(rowItem, rowIndex);
            }
          }}
        >
          {columns.map((cell, cellIndex) =>
            Boolean(cell?.Cell) ? (
              /* table action button */
              <TableCell
                className="max-w-[100px]"
                key={cellIndex}
              >
                {cell.Cell(rowItem)}
              </TableCell>
            ) : cell.accessor === 'Sno' ? (
              /* table serial number */
              showCheckBox ? <TableCell
                className={"tablecellonHover " + (rowItem?.isSelected ? " selectedStyle" : "")}
                key={cellIndex}
                style={{ width: '5%' }}
              >
                <div onClick={(e) => e.stopPropagation()}>
                <Checkbox checked={rowItem?.isSelected}
                  onChange={(e) => { 
                    if(onChangeCheckBox) {
                      onChangeCheckBox(rowIndex, e.target.checked, rowItem)
                    }
                  }} className={rowItem?.isSelected ? 'checkedItems' : 'checkboxonHover'} />
                </div>
               
                <Typography class={(rowItem?.isSelected ? 'indexChecked ' : 'indexStyle ') + `fs-12 ff-Roboto fw-regular `}>
                  {/* table serial number */}
                  {rowItem[cell.accessor]}
                </Typography>
              </TableCell> : <TableCell
                key={cellIndex}
                style={{ width: '5%' }}
              >
                <Typography class={ `fs-12 ff-Roboto fw-regular pl-[25px]`}>
                  {/* table serial number */}
                  {rowItem[cell.accessor]}
                </Typography>
              </TableCell>
            ) : cell.textWithIcon ? (
              <TableCell
                className="max-w-[100px]"
                key={cellIndex}
              >
                <Typography
                  style={{
                    ...cell?.style,
                    color: getTableTextColor(rowItem[cell.accessor]),
                    backgroundColor: cell?.bgColor ? getTableCellBgColor(rowItem[cell.accessor]) : 'transparent',
                  }}
                  class="fs-12 ff-Roboto fw-regular table-td-overflow !capitalize"
                >
                  {/* table text with icon */}
                  {cell.textWithIcon ? cell.icon() : null}
                  {/*  table data */}
                  {rowItem[cell.accessor] || '-'}
                </Typography>
              </TableCell>
            ) : (
              <TextOverFlowToolTip
                capitalize={cell?.capitalize}
                text={rowItem[cell.accessor]}
                key={cellIndex}
              />
            ),
          )}
        </TableRow>
      ))}
    </TableBody>
  );
}
